import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import { useHistory, useParams } from "react-router-dom";
import './index.css';
import api from '../../services/api_despesas';
import styles from "./styles.module.css";
import { FaEdit, FaPlusCircle, FaCheckCircle } from "react-icons/fa";
import { BsSearch, BsFillCheckCircleFill } from "react-icons/bs";
import moment from 'moment';
import Swal from 'sweetalert2';
import { mask, unMask } from 'remask';
import { parse } from 'date-fns';
import { format } from 'date-fns-tz';

export default function Parametros() {

    const [especialidades, setEspecialidades] = useState([]);
    const [selectedEspecialidade, setSelectedEspecialidade] = useState('');
    const [modalEspecialidadeOpen, setModalEspecialidadeOpen] = useState(false);
    const [modalCompartimentoOpen, setModalCompartimentoOpen] = useState(false);
    const [cenarios, setCenarios] = useState([]);
    const [safras, setSafras] = useState([]);
    const [safra, setSafra] = useState('');
    const [selectedCenario, setSelectedCenario] = useState('');
    const [compartimentos, setCompartimentos] = useState([]);
    const [descricao, setDescricao] = useState('');
    const [modalFrotasOpen, setModalFrotasopen] = useState(false);
    const [empresas, setEmpresas] = useState([]);
    const [modalAssociateFrotasOpen, setModalAssociateFrotasopen] = useState(false);
    const [pessoas, setPessoas] = useState([]);
    const [selectedPessoa, setSelectedPessoa] = useState({});
    const [inicioManut, setInicioManut] = useState('');
    const [fimManut, setFimManut] = useState('');
    const [matricula, setMatricula] = useState('');
    const [matriculaFiltro, setMatriculaFiltro] = useState('');
    const [nome, setNome] = useState('');
    const [modalConsultaPessoaOpen, setModalConsultaPessoaOpen] = useState(false);
    const [indexEmp, setIndexEmp] = useState('');
    const [indexFrota, setIndexFrota] = useState('');


    useEffect(() => {

        if (selectedCenario !== '' && selectedCenario !== '' && especialidades[selectedEspecialidade]) {
            api.get(`/compartimento/reforma?orc_cenarios_id=${selectedCenario}&fro_especialidade_id=${especialidades[selectedEspecialidade].id}`).then(function (response) {
                if (response.data) {
                    setCompartimentos(response.data);
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });
        }

    }, [selectedEspecialidade, selectedCenario]);

    useEffect(() => {
        api.get(`/cenario/safras`).then(function (response) {
            if (response.data) {
                setSafras(response.data);
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });

    }, []);

    useEffect(() => {
        if (selectedEspecialidade !== '') {
            const especialidade_id = especialidades[selectedEspecialidade].id;
            if (especialidades) {
                api.get(`/frota/byesp?fro_especialidade_id=${especialidade_id}`).then(function (response) {
                    if (response.data) {
                        setEmpresas(response.data);
                        console.log('empresas aqui', response.data);
                    }
                }).catch(function (error) {
                    // handle error
                    alert(error);
                    console.log(error);
                }).then(function () {
                    // always executed
                });
            }
        }

    }, [selectedEspecialidade, especialidades]);

    useEffect(() => {
        if (safra !== '') {
            api.get(`/cenario/getall?safra=${safra}`).then(function (response) {
                if (response.data) {
                    setCenarios(response.data);
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });
        }
    }, [safra]);

    useEffect(() => {
        if (selectedCenario !== '') {
            api.get(`/especialidade/reforma?orc_cenarios_id=${selectedCenario}`).then(function (response) {
                if (response.data) {
                    setEspecialidades(response.data);
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });
        }
    }, [selectedCenario]);

    function handleClickEspecialidade(id, index) {
        setSelectedEspecialidade(index);
    }

    function renderEspecialidadesReforma() {
        return (
            especialidades.map((especialidade, index) => {
                if (especialidade.especialidades_reforma[0] && especialidade.especialidades_reforma[0].fro_especialidade_id) {
                    if (especialidade.descricao.length > 25) {
                        return (
                            <div
                                className={(selectedEspecialidade === index ? styles.selectedespecialidade : styles.especialidade)}
                                onClick={() => handleClickEspecialidade(especialidade.id, index)}
                            >
                                {especialidade.descricao.substring(0, 25)}...
                            </div>
                        )
                    } else {
                        return (
                            <div
                                className={(selectedEspecialidade === index ? styles.selectedespecialidade : styles.especialidade)}
                                onClick={() => handleClickEspecialidade(especialidade.id, index)}
                            >
                                {especialidade.descricao}
                            </div>
                        )
                    }
                } else {
                    return (<></>)
                }

            })
        )
    }

    function fecharModalEspecialidade() {
        setModalEspecialidadeOpen(false);
    }


    function handleCheckEspecialidade(id, index) {

        var objEspec = Object.assign([], especialidades);
        var selected = objEspec[index];

        const body = {
            fro_especialidade_id: selected.id,
            orc_cenarios_id: selectedCenario,
        }

        if (selected.especialidades_reforma[0] && selected.especialidades_reforma[0].fro_especialidade_id) {
            api.put('/especialidade/desassociate', body).then(function (response) {
                if (response.data) {
                    selected.especialidades_reforma = [];
                    setEspecialidades(objEspec);
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });

        } else {
            api.put('/especialidade/associate', body).then(function (response) {
                if (response.data) {
                    selected.especialidades_reforma = [body];
                    setEspecialidades(objEspec);
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });

        }

    }

    function renderEspecialidades() {
        return (
            especialidades.map((especialidade, index) => {
                const isChecked = (especialidade.especialidades_reforma[0] && especialidade.especialidades_reforma[0].fro_especialidade_id);
                return (
                    <div
                        className={styles.especialidadecheck}
                        onClick={() => handleCheckEspecialidade(especialidade.id, index)}
                    >
                        <input type="checkbox" readOnly checked={isChecked || false} className={styles.check} />
                        {especialidade.descricao}
                    </div>
                )
            })
        )
    }

    function renderModalEspecialidades() {
        return (
            <div className={(modalEspecialidadeOpen ? styles.modalEsp : "modal-fechado")}>
                <span className="fechar-modal-previsoes" onClick={() => fecharModalEspecialidade()}>x</span>
                <div>
                    <h4>ESPECIALIDADES</h4>
                </div>
                <div className={styles.divespecialidades}>
                    {renderEspecialidades()}
                </div>
            </div>
        )
    }

    function renderCompartimentosReforma() {
        return (
            compartimentos.map((compartimento, index) => {
                if (compartimento.compartimento_reforma[0] && compartimento.compartimento_reforma[0].ref_compartimentos_id) {
                    if (compartimento.descricao.length > 25) {
                        return (
                            <div
                                className={styles.frotareforma}
                            >
                                {compartimento.descricao.substring(0, 25)}...
                            </div>
                        )
                    } else {
                        return (
                            <div
                                className={styles.frotareforma}
                            >
                                {compartimento.descricao}
                            </div>
                        )
                    }
                } else {
                    return (<></>)
                }

            })
        )
    }

    function handleOpenModalEspecialidade() {
        setModalEspecialidadeOpen(true);
    }

    function handleOpenCompartimento() {
        setModalCompartimentoOpen(true);
    }

    function renderEditCompartimentos() {
        if (canEdit()) {
            return (
                <FaEdit size="25" color='blue' className={styles.btnedit} onClick={() => handleOpenCompartimento()} />
            )
        }
    }

    function renderCompartimentos() {
        if (selectedEspecialidade !== '') {

            return (
                <div>
                    <div className={styles.divinfo}>
                        <div className={styles.label}>
                            COMPARTIMENTOS
                        </div>
                        {renderEditCompartimentos()}
                    </div>
                    <hr />
                    <div className={styles.divespecialidades}>
                        {renderCompartimentosReforma()}
                    </div>
                </div>
            )
        } else {
            return (<></>)
        }
    }

    function handleOpenModalFrotas() {
        setModalFrotasopen(true);
    }

    function renderRowFrotas(empresa) {
        return (
            empresa.frotas.map((frota, index) => {
                if (frota.frotas_reforma[0] && frota.frotas_reforma[0].fro_frota_id) {
                    return (
                        <div className={styles.frotareforma}>
                            {frota.cod_frota}
                        </ div>
                    )
                }
            })
        )
    }

    function renderRowEmpresas() {
        return (
            empresas.map((empresa, index) => {
                return (
                    <>
                        {renderRowFrotas(empresa)}
                    </>
                )
            })
        )
    }

    function renderEditFrotas() {
        if (canEdit()) {
            return (
                <FaEdit size="25" color='blue' className={styles.btnedit} onClick={() => handleOpenModalFrotas()} />
            )
        }
    }

    function renderFrotasReforma() {
        if (selectedEspecialidade !== '') {

            return (
                <div>
                    <div className={styles.divinfo}>
                        <div className={styles.label}>
                            FROTAS
                        </div>
                        {renderEditFrotas()}
                    </div>
                    <hr />
                    <div className={styles.divfrotasreforma}>
                        {renderRowEmpresas()}
                    </div>
                </div>
            )
        } else {
            return (<></>)
        }
    }

    function clickSafra(ano) {
        setSafra(ano);
        setEspecialidades([]);
        setSelectedCenario('');
        setSelectedEspecialidade('');
    }

    function renderBtnBorder(safra) {
        if (parseInt(safra) === parseInt(moment(new Date()).utc().format('YYYY'))) {
            return (styles.anoatual)
        } else if (parseInt(safra) < parseInt(moment(new Date()).utc().format('YYYY'))) {
            return (styles.anoanterior)
        } else {
            return (styles.anoproximo)
        }
    }

    function renderSafras() {
        return (
            safras.map((ano) => {
                return (
                    <input type="button" value={ano.safra}
                        className={renderBtnBorder(ano.safra)}
                        onClick={() => clickSafra(ano.safra)}
                    />
                )
            })
        )
    }

    function clickCenario(cenario) {
        setSelectedCenario(cenario);
        setSelectedEspecialidade('');
        // setEspecialidades([]);
    }

    function renderCenarios() {

        return (
            cenarios.map((cenario, index) => {
                if (cenario.status === 0) {
                    return (
                        <input id={cenario.id} type="button" className={styles.cenarioclosed} value={cenario.descricao} onClick={() => clickCenario(cenario.id)} />
                    )
                } else {
                    return (
                        <input id={cenario.id} type="button" className={styles.cenarioopen} value={cenario.descricao} onClick={() => clickCenario(cenario.id)} />
                    )
                }
            })
        )
    }

    function canEdit() {
        if (selectedCenario !== '') {
            const cenario = cenarios.find(cen => parseInt(cen.id) === parseInt(selectedCenario));
            const inicioPreenchimento = moment(cenario.inicio_preenchimento);
            const fimPreenchimento = moment(cenario.fim_preenchimento);
            const dataAtual = moment(new Date())

            if (inicioPreenchimento <= dataAtual && fimPreenchimento >= dataAtual) {
                return (true)
            } else {
                return (false)
            }
        }

    }

    function renderBtnEditEspecialidades() {
        if (canEdit()) {
            return (
                <FaEdit size="25" color='blue' className={styles.btnedit} onClick={() => handleOpenModalEspecialidade()} />
            )
        }
    }

    function renderConfig() {
        if (selectedCenario !== '') {
            return (
                <>
                    <div>
                        <div className={styles.divinfo}>

                            <div className={styles.label}>
                                ESPECIALIDADES
                            </div>
                            {renderBtnEditEspecialidades()}
                        </div>
                        <hr />
                        <div className={styles.divespecialidades}>
                            {renderEspecialidadesReforma()}
                        </div>
                    </div>
                    {renderCompartimentos()}
                    {renderFrotasReforma()}
                </>
            )
        } else {
            return (
                <></>
            )
        }
    }

    function fecharModalCompartimento() {
        setModalCompartimentoOpen(false);
    }


    function handleCheckCompartimento(id, index) {

        var objComp = Object.assign([], compartimentos);
        var selected = objComp[index];

        const body = {
            orc_cenarios_id: selectedCenario,
            ref_compartimentos_id: id,
            fro_especialidade_id: especialidades[selectedEspecialidade].id,
        }

        if (selected.compartimento_reforma[0] && selected.compartimento_reforma[0].ref_compartimentos_id) {
            api.put('/compartimento/desassociate', body).then(function (response) {
                if (response.data) {
                    selected.compartimento_reforma = [];
                    setCompartimentos(objComp);
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });

        } else {
            api.put('/compartimento/associate', body).then(function (response) {
                if (response.data) {
                    selected.compartimento_reforma = [body];
                    setCompartimentos(objComp);
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });

        }

    }



    function renderRowCompartimentos() {
        return (
            compartimentos.map((compartimento, index) => {
                const isChecked = (compartimento.compartimento_reforma[0] && compartimento.compartimento_reforma[0].ref_compartimentos_id);
                return (
                    <div className={styles.divcomp}>
                        <div
                            className={styles.especialidadecheck}
                            onClick={() => handleCheckCompartimento(compartimento.id, index)}
                        >
                            <input type="checkbox" readOnly checked={isChecked || false} className={styles.check} />
                            {compartimento.descricao}
                        </div>
                    </div>
                )
            })
        )
    }

    function renderModalCompartimentos() {
        return (
            <div className={(modalCompartimentoOpen ? styles.modalEsp : "modal-fechado")}>
                <span className="fechar-modal-previsoes" onClick={() => fecharModalCompartimento()}>x</span>
                <div>
                    <h4>COMPARTIMENTOS</h4>
                </div>
                <div className={styles.divespecialidades}>
                    {renderRowCompartimentos()}
                </div>
            </div>
        )
    }

    function fecharModalFrotas() {
        setModalFrotasopen(false);
    }

    function handleClickFrota(id, index, indexemp) {
        var ObjEmp = Object.assign([], empresas);
        var selectedEmp = ObjEmp[indexemp];
        var selectedFrota = selectedEmp.frotas[index];

        setIndexEmp(indexemp);
        setIndexFrota(index);

        const body = {
            orc_cenarios_id: selectedCenario,
            fro_frota_id: id,
        }

        if (selectedFrota.frotas_reforma[0] && selectedFrota.frotas_reforma[0].fro_frota_id) {
            api.put('/frota/desassociate', body).then(function (response) {
                if (response.data) {
                    selectedFrota.frotas_reforma = [];
                    setEmpresas(ObjEmp);
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });

        } else {

            setModalAssociateFrotasopen(true)


        }

    }

    function renderFrotas(empresa, indexemp) {
        if (empresa) {

            return (
                empresa.frotas.map((frota, index) => {
                    const isChecked = (frota.frotas_reforma[0] && frota.frotas_reforma[0].fro_frota_id);
                    return (
                        <div
                            className={styles.especialidadecheck}
                            onClick={() => handleClickFrota(frota.id, index, indexemp)}
                        >
                            <input type="checkbox" readOnly checked={isChecked || false} className={styles.check} />
                            {frota.cod_frota}
                        </div>
                    )
                })
            )
        }
    }

    function renderEmpresas() {
        return (
            empresas.map((empresa, index) => {
                return (
                    <div className={styles.contemp}>

                        <div><b>{empresa.descempresa}</b></div>
                        <div className={styles.divfrotas}>
                            {renderFrotas(empresa, index)}
                        </div>
                    </div>
                )
            })
        )
    }

    function renderModalFrotas() {
        return (
            <div className={(modalFrotasOpen ? styles.modalEsp : "modal-fechado")}>
                <span className="fechar-modal-previsoes" onClick={() => fecharModalFrotas()}>x</span>
                <div>
                    <h4>FROTAS</h4>
                </div>
                <hr />
                <br />
                <div className={styles.divempresas}>
                    {renderEmpresas()}
                </div>
            </div>
        )
    }

    function fecharModalAssociateFrotas() {
        setModalAssociateFrotasopen(false);
        setMatricula('');
        setSelectedPessoa({});
        setInicioManut('');
        setFimManut('');
    }

    function handleOpenModalBuscaPessoas() {
        setModalConsultaPessoaOpen(true);
    }

    function handleMaskData(value) {
        const originalValue = unMask(value);
        const maskedValue = mask(originalValue, [
            "9", "99", "99/9", "99/99", "99/99/9", "99/99/99", "99/99/999", "99/99/9999",
        ]);
        return (maskedValue);
    }

    function handleAddFrota() {

        if (!selectedPessoa || selectedPessoa.id === '') {
            Swal.fire('UM RESPONSÁVEL DEVERÁ SER INFORMADO!');
            return;
        }

        if (inicioManut === '') {
            Swal.fire('A DATA DE INICIO DA MANUTENÇÃO DEVERÁ SER INFORMADO!');
            return;
        }


        if (fimManut === '') {
            Swal.fire('A DATA DE FIM DA MANUTENÇÃO DEVERÁ SER INFORMADO!');
            return;
        }

        var ObjEmp = Object.assign([], empresas);
        var selectedEmp = ObjEmp[indexEmp];
        var selectedFrota = selectedEmp.frotas[indexFrota];




        const body = {
            orc_cenarios_id: selectedCenario,
            fro_frota_id: selectedFrota.id,
            pessoa_id: selectedPessoa.id,
            inicio_manut: format(parse(`${inicioManut}`, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd', { timeZone: 'America/Sao_Paulo' }),
            fim_manut: format(parse(`${fimManut}`, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd', { timeZone: 'America/Sao_Paulo' })
        }

        api.put('/frota/associate', body).then(function (response) {
            if (response.data) {
                selectedFrota.frotas_reforma = [body];
                setEmpresas(ObjEmp);
                fecharModalAssociateFrotas();
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });
    }

    function renderModalAssociateFrotas() {
        return (
            <div className={(modalAssociateFrotasOpen ? styles.modalEsp : "modal-fechado")}>
                <span className="fechar-modal-previsoes" onClick={() => fecharModalAssociateFrotas()}>x</span>
                <div>
                    <h4>DEFINIÇÕES DA REFORMA DA FROTA</h4>
                </div>

                <div className={styles.griinfo}>
                    <div className={styles.labels}>
                        <label>RESPONSÁVEL</label>
                        <label>INICIO REFORMA</label>
                        <label>FIM REFORMA</label>
                    </div>
                    <div className={styles.contents}>
                        <div>
                            <input type="text" value={matricula} onChange={(e) => setMatricula(e.target.value)} onKeyDown={(e) => handleDownPessoa(e)} />

                            <BsSearch onClick={() => handleOpenModalBuscaPessoas()} className={styles.btnconsultapessoas} />
                            <label>{selectedPessoa.nome} </label>
                        </div>
                        <input type="text" value={inicioManut} onChange={(e) => setInicioManut(handleMaskData(e.target.value))} />
                        <input type="text" value={fimManut} onChange={(e) => setFimManut(handleMaskData(e.target.value))} />
                    </div>

                </div>

                <BsFillCheckCircleFill size="40" color="green" className={styles.btnaddpessoa} onClick={() => handleAddFrota()} />

            </div >
        )
    }

    function fecharModalConsultaPessoas() {
        setPessoas([]);
        setMatriculaFiltro('');
        setNome('');
        setModalConsultaPessoaOpen(false);
    }

    function handleBuscarPessoa() {

        var filtros = "";

        if (nome && nome !== '') {
            if (filtros === '') {
                filtros = `?nome=${nome}`
            } else {
                filtros = `&nome=${nome}`
            }
        }


        if (matriculaFiltro && matriculaFiltro !== '') {
            if (filtros === '') {
                filtros = `?matricula=${matriculaFiltro}`
            } else {
                filtros = `&matricula=${matriculaFiltro}`
            }
        }

        api.get(`/pessoa/findbyemp${filtros}`).then(function (response) {
            if (response.data) {
                setPessoas(response.data)
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });
    }

    function handleClickPessoa(pessoa) {
        setSelectedPessoa(pessoa);
        setMatricula(pessoa.matricula);
        fecharModalConsultaPessoas();
    }

    function renderRowPessoas() {
        return (
            pessoas.map((pessoa, index) => {
                return (
                    <tr onClick={() => handleClickPessoa(pessoa)} className={styles.tbpessoa}>
                        <td>{pessoa.matricula}</td>
                        <td>{pessoa.nome}</td>
                    </tr>
                )
            })
        )
    }

    function handleDownPessoa(e) {
        console.log('entra aqui', e)
        if (e.key === "Enter") {
            console.log('passa')
            setSelectedPessoa({});
            api.get(`/pessoa/getbymatricula?matricula=${matricula}`).then(function (response) {
                if (response.data) {
                    setSelectedPessoa(response.data);
                    // setMatricula(response.data.matricula);
                    console.log('chama', response.data)
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });
        }
    }

    function renderModalConsultaPessoa() {
        return (
            <div className={(modalConsultaPessoaOpen ? styles.modalEsp : "modal-fechado")}>
                <span className="fechar-modal-previsoes" onClick={() => fecharModalConsultaPessoas()}>x</span>
                <div>
                    <h4>PESSOAS</h4>
                </div>

                <div className={styles.divparametrospessoas}>
                    <div className={styles.itempessoas}>
                        <label>MATRÍCULA</label>
                        <input type="text" value={matriculaFiltro} onChange={(e) => setMatriculaFiltro(e.target.value)} />
                    </div>
                    <div className={styles.itempessoas}>
                        <label>NOME</label>
                        <input type="text" value={nome} onChange={(e) => setNome(e.target.value)} />
                    </div>
                    <div className={styles.itempessoas}>
                        <input type="button" value="BUSCAR" className='btn btn-sm btn-primary' onClick={() => handleBuscarPessoa()} />
                    </div>
                </div>

                <table className='table table-sm'>
                    <thead>
                        <tr>
                            <th>MATRÍCULA</th>
                            <th>NOME</th>
                        </tr>
                    </thead>
                    <tbody>
                        {renderRowPessoas()}
                    </tbody>
                </table>

            </div>
        )
    }

    return (
        <>
            {renderModalEspecialidades()}
            {renderModalCompartimentos()}
            {renderModalFrotas()}
            {renderModalAssociateFrotas()}
            {renderModalConsultaPessoa()}
            <div className="container-lg">
                <Header title="ROTEIRO DA REFORMA" />
                <div>
                    {renderSafras()}
                </div>
                <div className={styles.divcenarios}>
                    {renderCenarios()}
                </div>
                {renderConfig()}
            </div>
        </>
    )
}